module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "counselors",
    staticClass: "group group--sidebar group--df-column",
    attrs: {
      "id": "counselors"
    }
  }, [_c('h1', {
    staticClass: "h1 group__title mw800",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("We've found some counselors for you in "), _c('span', [_vm._v(_vm._s(_vm.getState))])]), _vm._v(" "), _c('div', {
    staticClass: "results__header"
  }, [(!_vm.openSearch) ? _c('div', {
    staticClass: "results__search",
    on: {
      "click": function($event) {
        _vm.openSearch = true
      }
    }
  }, [_c('module-icon', {
    attrs: {
      "icon": "search"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "link fw-medium c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Search by name")])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "p c-mid"
  }, [_c('span', {
    staticClass: "link c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    on: {
      "click": function($event) {
        _vm.showStateModal = true
      }
    }
  }, [_vm._v("Change your state")]), _vm._v(" "), _c('br', {
    staticClass: "hide-above-medium"
  }), _vm._v(" "), _c('span', {
    staticClass: "ml hide-below-medium"
  }), _vm._v(" "), (!_vm.org.dfd_client) ? _c('span', {
    staticClass: "link fw-medium c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    on: {
      "click": _vm.navigateToF2f
    }
  }, [_vm._v(_vm._s(_vm.handlingF2fRedirect ? "Redirecting..." : "We also offer in-person sessions."))]) : _vm._e()])]), _vm._v(" "), _c('module-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showStateModal),
      expression: "showStateModal"
    }],
    attrs: {
      "modal": _vm.modalStateData
    },
    on: {
      "close": function($event) {
        _vm.showStateModal = false
      }
    }
  }, [_c('template', {
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "form results__state"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "form-fieldset"
  }, [_c('div', {
    staticClass: "form-field"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('select', {
    staticClass: "form-select",
    on: {
      "change": function($event) {
        return _vm.handleStateSelect($event)
      }
    }
  }, _vm._l((_vm.states), function(choice) {
    return _c('option', {
      key: choice.value,
      attrs: {
        "disabled": choice.label === _vm.getState
      },
      domProps: {
        "value": choice.value,
        "selected": choice.label === _vm.getState
      }
    }, [_vm._v("\n                    " + _vm._s(choice.label) + "\n                  ")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "form-arrow"
  })])])])])])]), _vm._v(" "), _c('template', {
    slot: "modal-footer"
  }, [_c('module-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.updateState.apply(null, arguments)
      }
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('module-button', {
    nativeOn: {
      "click": function($event) {
        _vm.showStateModal = false
      }
    }
  }, [_vm._v("Cancel")])], 1)], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "intake",
      "mode": "out-in"
    }
  }, [(_vm.openSearch) ? _c('div', {
    staticClass: "form-fieldset"
  }, [_c('div', {
    staticClass: "form-fieldset__wrapper"
  }, [_c('label', {
    class: ['form-label', {
      'form-label--focus': _vm.search.length > 0
    }],
    attrs: {
      "for": "search"
    }
  }, [_c('span', {
    staticClass: "form-label__label p"
  }, [_vm._v("Search by first or last name")])]), _vm._v(" "), _c('div', {
    class: ['form-field', {
      'form-field--focus': _vm.search.length > 0
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-input form-input--text",
    attrs: {
      "id": "search",
      "placeholder": "Search by first or last name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), (_vm.openSearch && _vm.allProviders.length <= 0) ? _c('div', {
    staticClass: "results__empty"
  }, [_c('p', {
    staticClass: "p c-error"
  }, [_vm._v("\n      Sorry, no results found for " + _vm._s(_vm.search) + ". Try again or use \"Load More\" to find more counselors available to you.\n    ")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "intake",
      "mode": "out-in"
    }
  }, [(_vm.loadingListOfProviders) ? _c('div', {
    staticClass: "list-provider__loader"
  }, [_c('module-dots', {
    attrs: {
      "active": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.loadingListOfProviders) ? _c('ul', {
    class: [
      'list-provider',
      {
        'list-provider--search-open': _vm.openSearch
      }
    ]
  }, _vm._l((_vm.allProviders), function(provider, index) {
    return _c('li', {
      key: provider.id,
      staticClass: "list-provider__item",
      on: {
        "click": function($event) {
          return _vm.select(provider)
        }
      }
    }, [_c('div', {
      staticClass: "list-provider__avatar",
      style: (_vm.formatAvatar(provider.photo_url_absolute))
    }), _vm._v(" "), _c('div', {
      staticClass: "list-provider__content"
    }, [_c('div', {
      staticClass: "list-provider__provider par"
    }, [(index === 0) ? _c('span', {
      staticClass: "list-provider__pill",
      style: ({
        'background-color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v("Top match")]) : _vm._e(), _vm._v(" "), _c('h2', {
      staticClass: "h2 list-provider__title",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(provider.fullname))]), _vm._v(" "), _c('span', {
      staticClass: "fw-bold c-mid"
    }, [_vm._v(_vm._s(provider.specialty))])]), _vm._v(" "), _c('div', {
      staticClass: "list-provider__availability"
    }, [(provider.next_appt_available_date) ? _c('span', {
      staticClass: "c-mid"
    }, [_vm._v("Available " + _vm._s(_vm._f("readableDateTime")(provider.next_appt_available_date)))]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "list-provider__link fw-bold",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v("Find a time to talk")])])])])
  }), 0) : _vm._e()]), _vm._v(" "), (!_vm.loadingListOfProviders) ? _c('div', {
    staticClass: "results__pagination"
  }, [_c('module-button', {
    staticClass: "mt",
    attrs: {
      "label": !_vm.noResults ? "Load More" : "All results loaded",
      "button": "primary",
      "disabled": _vm.noResults
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextResults.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('module-disclaimer', {
    staticClass: "disclaimer--results"
  }), _vm._v(" "), _c('article', {
    staticClass: "bbg bbg--white group group--wide"
  }, [_c('section', {
    ref: "approach",
    staticClass: "section section--approach ovh",
    attrs: {
      "id": "approach"
    }
  }, [_c('h1', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Get the right help from the right person")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("There’s no one-size-fits-all solution to feeling better. So our network includes counselors who specialize in different areas of emotional health.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Question about your results? Want to talk to someone in person? Please give us a call at "), _c('a', {
    staticClass: "fw-bold c-accent tdn link",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    }),
    attrs: {
      "href": ("tel:" + _vm.number)
    }
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(".")])]), _vm._v(" "), _c('section', {
    staticClass: "section section--things-to-know",
    attrs: {
      "id": "things-to-know"
    }
  }, [_c('h1', {
    staticClass: "h1 mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Some other things to know"), _c('br', {
    staticClass: "hide-below-medium"
  }), _vm._v(" about how this works")]), _vm._v(" "), _c('div', {
    staticClass: "section__group"
  }, [_c('div', {
    staticClass: "section__group-item"
  }, [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("It's already paid for")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Your employer covers the cost for you and your family members. That means no bills, no co-pays, no surprise fees, and no need to involve your insurance company.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("It’s confidential")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Your conversations are private, so your employer won’t know who you talked to or what you said.")])]), _vm._v(" "), _c('div', {
    staticClass: "section__group-item"
  }, [_c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("It’s based around you")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("You’ll choose how you want to talk: over the phone or using video chat. You’ll get personalized, one-on-one help. And if you ever need anything, you’ll always be able to call us.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("It’s quality experts only")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("You’ll be connected with someone who’s been vetted, screened, and approved by our team.")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5534d6a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/provider/Results.vue
// module id = 502
// module chunks = 0